import { TYPE_LINK } from '@eventbrite/eds-button';
import { IconButton } from '@eventbrite/eds-icon-button';
import {
    GlobeChunky,
    LogoFacebook,
    LogoTwitter,
} from '@eventbrite/eds-iconography';
import { openInNewTab } from '@eventbrite/http';
import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import { css } from 'emotion';
import React from 'react';
import { GACodes, SocialLinksProps } from '../../types';

const handleClick = (label: string, href: string) => {
    trackAnalyticsEvent({
        action: GACodes.GA_ACTION_SOCIAL_LINK_CLICK,
        category: GACodes.GA_CATEGORY_LISTING,
        label: label,
    });

    openInNewTab(href);
};

const SocialLinks: React.FunctionComponent<SocialLinksProps> = (props) => {
    const { orgFacebook, orgTwitter, orgWebsite } = props;
    const hasSocialLinks = orgWebsite || orgTwitter || orgFacebook;
    const facebookHref = `https://www.facebook.com/${orgFacebook}`;
    const twitterHref = `https://www.twitter.com/${orgTwitter}`;
    const websiteHref = `${orgWebsite}`;

    if (!hasSocialLinks) {
        return null;
    }

    return (
        <div className={css(styles.socialLinks)} data-testid="socialLinks">
            {orgFacebook && (
                <IconButton
                    type={TYPE_LINK}
                    title={gettext('Facebook profile')}
                    iconType={<LogoFacebook />}
                    onClick={() =>
                        handleClick(GACodes.GA_LABEL_FACEBOOK, facebookHref)
                    }
                    href={facebookHref}
                />
            )}
            {orgTwitter && (
                <IconButton
                    type={TYPE_LINK}
                    title={gettext('Twitter profile')}
                    iconType={<LogoTwitter />}
                    onClick={() =>
                        handleClick(GACodes.GA_LABEL_TWITTER, twitterHref)
                    }
                    href={twitterHref}
                />
            )}
            {orgWebsite && (
                <IconButton
                    type={TYPE_LINK}
                    title={gettext('Organizer website')}
                    iconType={<GlobeChunky />}
                    onClick={() =>
                        handleClick(GACodes.GA_LABEL_WEBSITE, websiteHref)
                    }
                    href={websiteHref}
                />
            )}
        </div>
    );
};

export default SocialLinks;

const styles = {
    socialLinks: css`
        margin: 8px 0 40px 0;
        .eds-icon-button {
            background-color: #eeedf2;
            padding: 11px;
            border-radius: 50%;
            margin: 0 16px 0 16px;
        }
    `,
};
